import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import type { LeadPipelineStage } from "@/app/services/generated/leadpipelinestageService";
import { leadPipelineStageService } from "@/app/services/generated/leadpipelinestageService";

// Singleton cache store
const leadPipelineStagesCacheStore = new EntityCacheStore<LeadPipelineStage>(
  EnumCacheEntityType.leadPipelineStage,
  async () => leadPipelineStageService.getAllLeadPipelineStages()
);

// Ephemeral reader
export default class LeadPipelineStagesCache extends EntityWithGuidKeyCache<LeadPipelineStage> {
  constructor() {
    super(leadPipelineStagesCacheStore, (x) => x.id);
  }

  public get allOrderedReactive() {
    return Object.freeze(
      [...this.allReactive.value].sort(
        (orderA, orderB) => orderA.readOnly.ordering - orderB.readOnly.ordering
      )
    );
  }
}
